import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../stem-core/src/ui/Style";

import {Messages} from "../../../../Messages";
import {InfoIcon} from "../../../../SVGElements";
import {AutoReloadPopup} from "./AutoReloadPopup";
import {UserPreferencesStore} from "../../../../State";
import {LoadingWidget} from "../../../ui/LoadingWidget";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {WalletToggleButton} from "../../../ui/WalletButton";
import {apiUpdatePreferences} from "../../../../../client/state/UserPreferencesStore";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {Direction} from "../../../../../stem-core/src/ui/Constants";


class AutoReloadStyle extends StyleSheet {
    @styleRule
    autoReloadInfo = {
        position: "absolute",
        display: "inline-block",
        marginLeft: 6,
        transform: "translateY(2px)",
        cursor: "pointer",
        ":hover g": {
            fill: this.themeProps.WALLET_AUTO_RELOAD_HOVER,
        }
    };

    @styleRule
    autoReloadWidget = {
        display: "flex",
        justifyContent: "space-between",
    }
}

@registerStyle(AutoReloadStyle)
@autoredraw(UserPreferencesStore)
export class AutoReload extends UI.Element {
    getPreferences() {
        return UserPreferencesStore.getPreferences();
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.autoReloadWidget);
    }

    render() {
        const {styleSheet} = this;
        const {autoTopUpEnabled} = this.getPreferences();

        return [
            <span>
                {Messages.autoReload}
                <InfoIcon className={styleSheet.autoReloadInfo} ref="infoIcon" />
            </span>,
            <WalletToggleButton testId="walletAutoReloadToggle" ref="autoReloadToggle" active={autoTopUpEnabled}
                                onToggle={(active) => this.updateAutoReload(active)}/>
        ];
    }

    async updateAutoReload(autoReload) {
        const preferences = this.getPreferences();
        preferences.autoTopUpEnabled = autoReload;

        try {
            await LoadingWidget.walletLoad(() => apiUpdatePreferences(preferences.getFields()));
        } catch(e) {
            // TODO: handle this case
        } finally {
            this.redraw();
        }
    }

    onMount() {
        super.onMount();

        this.infoIcon.addNodeListener("mouseenter", () => {
            AutoReloadPopup.show({anchor: this.infoIcon, hideOnMouseLeave: true, showOnSameAnchor: true,
                direction: Direction.DOWN});
        });
    }
}
